/* Hallmark · component: consent notice · genre: editorial · theme: host_ui.css
 * states: default · hover · focus-visible · active · visited
 * contrast: muted-foreground on background 4.59:1 · foreground on background 12.4:1
 */
import React from "react";

// One notice per page, closing the card under every way off it. Naming no
// single route is what lets it leave the buttons: the same sentence printed
// twice, once per route, reads as boilerplate and gets skipped both times.
// Placement is the caller's — this only owns the sentence.

// The links are deliberately not gold. design.md spends the accent on the
// primary action; a gold link next to the CTA outshouts it. Weight and a
// hairline rule carry the affordance instead, matching the shared footer's
// treatment of these same two documents.
const linkClass =
  "whitespace-nowrap font-medium text-foreground underline decoration-foreground/40 underline-offset-4 transition-colors hover:decoration-foreground focus-visible:rounded-xs focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring";

export function AuthConsentNotice() {
  return (
    <p data-auth-consent-notice className="text-sm leading-relaxed text-muted-foreground">
      By continuing you agree to our{" "}
      <a href="/terms" target="_blank" rel="noopener" className={linkClass}>
        Terms of Service
      </a>{" "}
      and{" "}
      <a href="/privacy" target="_blank" rel="noopener" className={linkClass}>
        Privacy Policy
      </a>
      .
    </p>
  );
}
